import { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { useNFTS } from '../../hooks/useNFTS';
import { abi as MinterABI } from '../../config/abis/mintABI.json'
import axios from 'axios';
import { IAccount } from '../../types';
import { useAccount } from '../../hooks/useAccount';

const MintedCard = (props: any) => {
  const [supply, setSupply] = useState('0');
  const [minted, setMinted] = useState('0');
  const [priceETH, setPriceETH] = useState('0');
  const [priceUSD, setPriceUSD] = useState('0');
  const myNFTs = useNFTS();
  let _account: IAccount = useAccount();
  const { ...account } = _account as any;

  const init = async () => {
    if (myNFTs.nfts.supplyData) {
      const totalSupply = myNFTs.nfts.supplyData.supply;
      const totalMinted = myNFTs.nfts.supplyData.minted;
      //const priceETH = myNFTs.nfts.supplyData.priceETH;
      //const priceUSD = myNFTs.nfts.supplyData.priceUSD;
      setSupply(totalSupply);
      setMinted(totalMinted);
      // setPriceETH(priceETH);
      // setPriceUSD(priceUSD);
    }
  };

  useEffect(() => {
    if (account.account) {
      init();
      getMonsterExchangeRate();
    }
  }, [myNFTs]);

  const getMonsterExchangeRate = async () => {
    try {

      const provider = new ethers.providers.Web3Provider(window.ethereum as any);
      const signer = provider.getSigner();
      const MintContract = new ethers.Contract('0x15682F397286BC1429098394a76Bf4f13F7925Df', MinterABI, signer);

      const prrice = await MintContract.getPrice();
      setPriceETH(parseFloat(ethers.utils.formatEther(prrice._hex).toString()).toFixed(6))
      //setPriceETH((price).toFixed(6).toString());
      const ethPriceInUSDResponse = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd");
      const ethPriceInUSD = ethPriceInUSDResponse.data.ethereum.usd;
      setPriceUSD((Number(priceETH) * ethPriceInUSD).toLocaleString());

    } catch (error) {
      console.log(error)
    }
  };

  return (
    <div className="minted-card">
      <div className="card-header">
        <h1>{props.nameToken}</h1>
      </div>
      <div className="minted-body">
        <div className="price">
          <span>${priceUSD} USD</span>
          <small>{priceETH} ETH</small>
        </div>
        <div className="supply">
          <small>minted</small>
          <span>
            {minted.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MintedCard;